<template>
  <div style="height: 100vh; width: 100%">
    <div style="width: 100%; display: none; height: 0%">
      <img id="imageid" :src="profpic" />
      <canvas id="imgCanvas" />
      <pdf-make
        ref="pdfMake"
        style="width: 100%"
        :content="content"
        :pageSize="'A4'"
        :pageOrientation="'portrait'"
        :styles="styles"
        :defaultStyle="defaultStyle"
        :show="true"
        :info="{ title: title }"
        @change="
          (e) => {
            src = e;
          }
        "
      >
      </pdf-make>
    </div>
    <iframe
      id="content-frame"
      :src="src"
      style="width: 100%; display: inline-block; height: 100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import PdfMake from "@/components/PdfMake";
import {
  docContent,
  docStyles,
  docDefaultStyle,
} from "@/data/TemplatePeriksaPasien.js";
// import ttf from 'url-loader!@/assets/微软雅黑.ttf'
//console.log(ttf)
export default {
  name: "DocPeriksaPasien",
  components: {
    PdfMake,
  },
  data() {
    return {
      title: "Example",
      src: "",
      content: [],
      styles: docStyles,
      defaultStyle: docDefaultStyle,
      profpic: "https://103.27.207.58/backend/public/images/icon_customer.png",
    };
  },
  methods: {
    executeDocument: function() {
      // let doc=document;
      //console.log(doc);
      // setTimeout(() => {
      //     doc.getElementById('content-frame').contentWindow.window.print();
      //     //console.log(doc.getElementById('content-frame'));
      // }, 1000);
      // if(this.src){
      document.getElementById("content-frame").contentWindow.window.print();
      // }
      //console.log(doc.getElementById('content-frame'));
    },
    toDataUrl: function(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    // var can = document.getElementById("imgCanvas");
    // var img = document.getElementById("imageid");
    // var ctx = can.getContext("2d");
    // ctx.drawImage(img, 10, 10);
    // var encodedBase = can.toDataURL();
    //console.log(encodedBase);
    // this.toDataUrl('https://103.27.207.58/backend/public/images/icon_customer.png', function(myBase64) {
    //   //console.log(myBase64); // myBase64 is the base64 string
    // });
    this.content = docContent;
  },
  // watch:{
  //   src:function(){
  //     document.getElementById('content-frame').contentWindow.window.print();
  //   }
  // }
};
</script>
